module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_rn-1c18638398870d08dacf308677a42e33.gif";